import React from "react";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import ErrorScreen from "core/components/ErrorScreen";
import Box from "@mui/material/Box";

export default function NoMatchScreen() {
  const { t } = useTranslation("player");

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Helmet>
        <title>{t("noMatchScreen.title")}</title>
      </Helmet>
      <ErrorScreen
        icon={SentimentVeryDissatisfiedIcon}
        title={t("noMatchScreen.title")}
        text={t("noMatchScreen.text")}
      />
    </Box>
  );
}
